/**
 * Supported report types. Used to differentiate report formats and enable
 * scalable support for multiple report variants.
 */
export const ReportTypes = {
	EightyTwenty: 'eighty-twenty',
	QBR: 'qbr',
} as const;

export type ReportType = (typeof ReportTypes)[keyof typeof ReportTypes];
